import React, { useState } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Auth/login`,
        { email, password }
      );

      const token = response.data.token;
      localStorage.setItem("token", token);

      // const decoded = jwtDecode(token);
      // const user = {
      //   name: decoded.name || "Guest",
      //   role: decoded.role || "Unknown",
      // };

       // Dekodowanie tokenu JWT, aby wyciągnąć dane użytkownika
    const decoded = jwtDecode(token);
    const user = {
      name: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] || "Guest",
      email: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"] || null,
      role: decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || "Unknown",
    };

      localStorage.setItem("user", JSON.stringify(user));

      alert("Login successful!");
      window.location.href = "/events";
    } catch (err) {
      console.error(err);
      setError("Invalid email or password");
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white shadow-lg rounded-lg p-6 mt-12">
      <h1 className="text-2xl font-bold text-center mb-4">Login</h1>
      <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <label className="block text-gray-700">Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full bg-white border border-gray-300 rounded px-3 py-2 mt-1 focus:ring focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-gray-700">Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full bg-white border border-gray-300 rounded px-3 py-2 mt-1 focus:ring focus:ring-blue-500"
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
        >
          Login
        </button>
      </form>
      {error && <p className="text-center text-red-500 mt-4">{error}</p>}
    </div>
  );
}

export default LoginPage;
